import React, { useEffect, useContext } from 'react';
import { Shield, Users, Send, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../context/AppContext';

// Image import
import groupes from "../../images/groupes.png";

const RelierBot = () => {
  const navigate = useNavigate();
  const { setupTelegramBackButton, ontg } = useContext(AppContext);
  
  // Utiliser la fonction du contexte pour gérer le bouton retour
  useEffect(() => {
    // Configurer le bouton retour avec la fonction du contexte
    const backButtonShown = setupTelegramBackButton(true, () => navigate(-1));
    
    // Nettoyer lors du démontage du composant
    return () => {
      if (backButtonShown) {
        setupTelegramBackButton(false);
      }
    };
  }, [navigate, setupTelegramBackButton]);

  const handleClick = (type) => {
    if (type === 'channel') {
      // Pour les canaux
      const link = 'https://t.me/KappelaVendeurBot?startchannel=true';
      if (navigator.userAgent.match(/iPhone|iPad|iPod|Macintosh/i)) {
        // Comportement spécial pour iOS/macOS
        window.location.href = link;
        setTimeout(() => navigate("/GroupeListe"), 1000);
      } else {
        // Pour Windows/Android et autres
        window.open(link, '_blank');
        navigate("/GroupeListe");
      }
    } else {
      // Pour les groupes
      const link = 'https://t.me/KappelaVendeurBot?startgroup=true';
      if (navigator.userAgent.match(/iPhone|iPad|iPod|Macintosh/i)) {
        // Comportement spécial pour iOS/macOS
        window.location.href = link;
        setTimeout(() => navigate("/GroupeListe"), 1000);
      } else {
        // Pour Windows/Android et autres
        window.open(link, '_blank');
        navigate("/GroupeListe");
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-indigo-50">
      {/* Header */}
      <div className="p-4 flex items-center">
        <button 
          onClick={() => navigate(-1)}
          className="p-2 rounded-full bg-white shadow-sm"
        >
          <ArrowLeft className="w-5 h-5 text-gray-700" />
        </button>
        <h1 className="ml-4 text-xl font-semibold text-gray-800">Connecter à Telegram</h1>
      </div>
      
      {/* Main Content */}
      <main className="p-6">
        {/* Illustration */}
        <div className="relative h-48 mb-6 flex justify-center">
          <img 
            src={groupes} 
            alt="Illustration" 
            className="h-56 md:h-64 object-contain"
          />
        </div>

        {/* Text Content */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-4">Connectez notre bot</h2>
          <p className="mb-6">
            Connectez <span className="text-blue-600">@KappelaVendeurBot</span> à votre canal ou groupe en lui donnant les permissions suivantes :
          </p>
          
          <ul className="space-y-3 mb-6">
            <li className="flex items-center">
              <div className="bg-blue-100 p-2 rounded-full mr-3">
                <Shield className="w-4 h-4 text-blue-600" />
              </div>
              Gérer le groupe/canal
            </li>
            <li className="flex items-center">
              <div className="bg-indigo-100 p-2 rounded-full mr-3">
                <Users className="w-4 h-4 text-indigo-600" />
              </div>
              Bannir des utilisateurs
            </li>
            <li className="flex items-center">
              <div className="bg-purple-100 p-2 rounded-full mr-3">
                <Send className="w-4 h-4 text-purple-600" />
              </div>
              Inviter des utilisateurs avec liens
            </li>
          </ul>

          {/* Buttons */}
          <div className="grid grid-cols-2 gap-4">
            <button 
              className="flex items-center justify-center space-x-2 bg-blue-600 text-white py-3 px-4 rounded-xl hover:bg-blue-700 transition-colors"
              onClick={() => handleClick('channel')}
            >
              <Send className="w-5 h-5 -rotate-45" />
              <span>Canal</span>
            </button>

            <button 
              className="flex items-center justify-center space-x-2 bg-gray-800 text-white py-3 px-4 rounded-xl hover:bg-gray-900 transition-colors"
              onClick={() => handleClick('group')}
            >
              <Users className="w-5 h-5" />
              <span>Groupe</span>
            </button>
          </div>
        </div>
        
        {/* Alternative Option */}
        <button 
          onClick={() => navigate('/GroupeListe')}
          className="w-full bg-gray-100 text-gray-700 rounded-xl py-3 font-medium hover:bg-gray-200 transition-colors"
        >
          Voir mes groupes existants
        </button>
      </main>
    </div>
  );
};

export default RelierBot;